import { Component, OnInit } from '@angular/core';
import {Slider} from '../../models/slider';
import {Router} from '@angular/router';
import {SliderService} from '../../services/slider.service';
import {BaseService} from '../../base.service';
import { ContractsService } from '../../services/contracts.service';
import { ContractListItem } from '../../models/contractListItem';
import { ContractListItemSource } from '../../models/contractListItemSource';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: []
})
export class ContractListComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;
  private contracts:ContractListItem[] = [];
  private sliderId: number;
  
  total = 10000000;
  bigCurrentPage: number = 1;
  maxSize: number = 5;
  size: number = 10;
  page: number = 1;
  status: string = '';

  filter_dni_p: string = '';
  filter_ruc_p: string = '';
  filter_dni_i: string = '';
  filter_estado: string = 'A';

  constructor(
    private router: Router,
    private service: ContractsService,
    private baseService: BaseService
  ) {}
    //45878206
  ngOnInit() {
    this.titleComponent = 'Contratos';
    this.titlePanel = 'Lista de Contratos';
    this.baseService.changedComponentName(this.titleComponent);

    this.list( 0 , this.filter_dni_p , this.filter_ruc_p , this.filter_estado , this.filter_dni_i );
  }

  list( page:number = 0 , ownerDni:string = "" , ownerRuc:string = "" , status:string = "" , tenantDni:string = "" ) {
    this.service.getAll( page , ownerDni , ownerRuc , status , tenantDni , this.size).subscribe(d => {
      console.log(d);
      
      if (d) {
        this.contracts = [];
        let data:any = d;
        let pContracts:ContractListItemSource[] = data.content;
        pContracts.map( r => {
          this.contracts.push( {
            id: r.id,
            tenantFullName: r.tenant.name + ' ' + r.tenant.lastName,
            tenantDNI: r.tenant.dni,
            status: r.status,
            propertyFullName: r.property.fullName,
            propertyDNI: r.property.dni,
            propertyRUC: r.property.ruc,
            cantidad : r.amount,
            amountToReceive: r.amountToReceive + ' ' + r.currencyCode,
            creationDate: r.creationDate,
            dayMonth: r.dayMonth,
            divisionName: r.division.name
          } );
        });
        this.total = data.totalElements;
        this.page = data.number;
        
      }
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/contracts', id];
    this.router.navigate(link);
  }


  pageChanged(event: any): void {
    this.list( event.page -1 , this.filter_dni_p , this.filter_ruc_p , this.filter_estado , this.filter_dni_i );
  }

  filtrar(){
    this.list( 0 , this.filter_dni_p , this.filter_ruc_p , this.filter_estado , this.filter_dni_i );
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/contract/contract-list.component.ts